module.exports = function getApiErrorMessage(err, fallback) {

    const data = err?.response?.data;

    if (typeof data?.message === 'string' && data.message.trim()) {
        return data.message;
    }

    if (typeof data?.error === 'string' && data.error.trim() && data.error !== 'Bad Request') {
        return data.error;
    }

    return fallback;
};
